<template>
  <div class="content-container">
    <search-comp :search-show="true" @onSearch="attachData" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('searchBox.status') }}</div>
                <select-with-search-table
                  :columns="searchColumn1"
                  :rows="searchRows1"
                  index-field="value"
                  :selected-index-field-value="searchParams.requireStatus"
                  :is-remove-btn="true"
                  multiple
                  @selectionChanged="onSelectMultipleRowSearch1"
                >
                  <template v-slot:value="{ selectedValue: selectedData }">
                    <span v-for="data in selectedData" :key="data.value"
                      >{{ data.name }},
                    </span>
                  </template>
                </select-with-search-table>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('searchBox.workType') }}</div>
                <el-select v-model="searchParams.workType" placeholder="">
                  <el-option
                    v-for="option in workTypeOptions"
                    :key="option.id"
                    :label="option.desc"
                    :value="option.id"
                  >
                  </el-option>
                </el-select>
                <!-- <select v-model="searchParams.workType" placeholder="Chọn">
                  <option :value="null">Chọn</option>
                  <option
                    v-for="option in workTypeOptions"
                    :key="option.id"
                    :value="option.id"
                  >
                    {{ option.desc }}
                  </option>
                </select> -->
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('searchBox.room') }}</div>
                <el-select v-model="searchParams.roomId" placeholder="">
                  <el-option
                    v-for="option in roomOptions"
                    :key="option.id"
                    :label="option.room_number"
                    :value="option.id"
                  >
                  </el-option>
                </el-select>
                <!-- <select v-model="searchParams.roomId" placeholder="Chọn">
                  <option :value="null">Chọn</option>
                  <option
                    v-for="option in roomOptions"
                    :key="option.id"
                    :value="option.room_number"
                  >
                    {{ option.room_number }}
                  </option>
                </select> -->
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('searchBox.date') }}</div>
                <CalendarRange
                  v-model="searchDateRange"
                  style="display: block"
                  mode="date"
                />
                <!-- <MultiCalendar
                  :from-date="null"
                  :to-date="null"
                  class="use-icon"
                  @changeDate="onChangeDate"
                /> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div class="processing-result">
      <div class="item">
        <div class="badge">{{ requireResultList.total }}</div>
        <div class="text">{{ $t('variables.total') }}</div>
      </div>
      <div class="item">
        <div class="badge new">{{ requireResultList.new }}</div>
        <div class="text new">{{ $t('variables.newRequest') }}</div>
      </div>
      <!-- <div class="item">
        <div class="badge received">{{ requireResultList.received }}</div>
        <div class="text received">{{ $t('variables.received') }}</div>
      </div>
      <div class="item">
        <div class="badge rejected">{{ requireResultList.rejected }}</div>
        <div class="text rejected">{{ $t('variables.rejected') }}</div>
      </div> -->
      <div class="item">
        <div class="badge completed">{{ requireResultList.completed }}</div>
        <div class="text completed">{{ $t('variables.completed') }}</div>
      </div>
    </div>
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        dom-layout="scroll"
        :auto-select-first-row="false"
        :rows="rows"
        class="agGrid"
        @selectionChanged="selectionChanged"
      />
    </div>
    <div class="grid-bottom">
      <GridPaging
        target="agGrid"
        :total-size="totalPage"
        :page-num="currentPage"
        :page-size="searchParams.pageSize"
        @pageChanged="onPageChanged"
        @onPageSizeChange="onPageSizeChange"
      />
    </div>
    <div class="button-containers">
      <button
        :disabled="!rowSelected.length"
        class="btn primary small outline"
        @click="onDeleteRow"
      >
        {{ this.$t('button.delete') }}
      </button>
      <button
        :disabled="!rowSelected.length || rowSelected[0]?.require_status === 4"
        class="btn primary small outline"
        @click="onEditRow"
      >
        {{ this.$t('button.modify') }}
      </button>
      <button class="btn primary small" @click="dialogFormVisible = true">
        {{ this.$t('button.add') }}
      </button>
      <!-- <button disabled class="btn primary small">In yêu cầu</button> -->
    </div>
    <el-dialog
      :title="isEdit ? 'Sửa yêu cầu' : 'Thêm yêu cầu'"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="700px"
    >
      <div class="content-box">
        <div class="section-box">
          <div class="das-form-container">
            <validation-observer ref="formValidator">
              <div class="das-form-group">
                <div class="das-form-row">
                  <div class="das-form-col col-4">
                    <validation-provider rules="required" name="Ngày yêu cầu">
                      <div class="das-form-input">
                        <div class="label required">Ngày yêu cầu</div>
                        <SingleCalendar
                          v-model="item.date_from"
                          :get-time="true"
                          :min-max="{
                            min: $moment(new Date()).format('YYYY-MM-DD')
                          }"
                        />
                      </div>
                    </validation-provider>
                  </div>
                  <div class="das-form-col col-4">
                    <validation-provider rules="required" name="Yêu cầu bởi">
                      <div class="das-form-input">
                        <div class="label required">Yêu cầu bởi</div>
                        <input v-model="item.require_by" type="text" />
                      </div>
                    </validation-provider>
                  </div>
                  <div class="das-form-col col-4">
                    <validation-provider rules="required" name="Ưu tiên">
                      <div class="das-form-input">
                        <div class="label required">Ưu tiên</div>
                        <el-select v-model="item.priority_type" placeholder="">
                          <el-option label="Thấp" :value="1"> </el-option>
                          <el-option label="Trung bình" :value="2"> </el-option>
                          <el-option label="Cao" :value="3"> </el-option>
                        </el-select>
                        <!-- <select v-model="item.priority_type">
                          <option value="1">Thấp</option>
                          <option value="2">Trung bình</option>
                          <option value="3">Cao</option>
                        </select> -->
                      </div>
                    </validation-provider>
                  </div>
                </div>
                <div class="das-form-row">
                  <div class="das-form-col col-4">
                    <validation-provider rules="required" name="Loại việc">
                      <div class="das-form-input">
                        <div class="label required">Loại việc</div>
                        <el-select v-model="item.work_type" placeholder="">
                          <el-option
                            v-for="option in workTypeOptions"
                            :key="option.id"
                            :label="option.desc"
                            :value="option.id"
                          >
                          </el-option>
                        </el-select>
                        <!-- <select v-model="item.work_type">
                          <option
                            v-for="option in workTypeOptions"
                            :key="option.id"
                            :value="option.id"
                          >
                            {{ option.desc }}
                          </option>
                        </select> -->
                      </div>
                    </validation-provider>
                  </div>
                  <div class="das-form-col col-4">
                    <validation-provider rules="required" name="Phòng">
                      <div class="das-form-input">
                        <div class="label required">Phòng</div>
                        <el-select v-model="item.room_id" placeholder="">
                          <el-option
                            v-for="option in roomOptions"
                            :key="option.id"
                            :label="option.room_number"
                            :value="option.id"
                          >
                          </el-option>
                        </el-select>
                        <!-- <select v-model="item.room_id">
                          <option
                            v-for="option in roomOptions"
                            :key="option.id"
                            :value="option.id"
                          >
                            {{ option.room_number }}
                          </option>
                        </select> -->
                      </div>
                    </validation-provider>
                  </div>
                  <div class="das-form-col col-4">
                    <validation-provider rules="required" name="Vị trí bảo trì">
                      <div class="das-form-input">
                        <div class="label required">Vị trí bảo trì</div>
                        <el-select
                          v-model="item.maintenance_position"
                          placeholder=""
                        >
                          <el-option
                            v-for="option in repairLocationOptions"
                            :key="option.id"
                            :label="option.desc"
                            :value="option.id"
                          >
                          </el-option>
                        </el-select>
                        <!-- <select v-model="item.maintenance_position">
                          <option
                            v-for="option in repairLocationOptions"
                            :key="option.id"
                            :value="option.id"
                          >
                            {{ option.desc }}
                          </option>
                        </select> -->
                      </div>
                    </validation-provider>
                  </div>
                </div>
                <div class="das-form-row">
                  <div class="das-form-col col-4">
                    <validation-provider
                      rules="required"
                      name="Mô tả công việc"
                    >
                      <div class="das-form-input">
                        <div class="label required">Lý do</div>
                        <el-select v-model="item.desc" placeholder="">
                          <el-option
                            v-for="option in reasonOptions"
                            :key="option.id"
                            :value="option.id"
                            :label="option.desc"
                          >
                          </el-option
                        ></el-select>
                        <!-- <textarea v-model="item.desc" style="width: 100%" /> -->
                      </div>
                    </validation-provider>
                  </div>
                  <div class="das-form-col col-8">
                    <div class="das-form-input">
                      <div class="label required">Tác vụ đi kèm</div>
                      <div class="checkbox-container">
                        <div class="checks-wrap">
                          <input
                            id="cpSpdTp3"
                            v-model="item.assign_action"
                            :value="0"
                            name="assignAction"
                            type="radio"
                          />
                          <label for="cpSpdTp3">Không có</label>
                        </div>
                        <div class="checks-wrap">
                          <input
                            id="cpSpdTp4"
                            v-model="item.assign_action"
                            :value="1"
                            name="assignAction"
                            type="radio"
                          />
                          <label for="cpSpdTp4">Tạo OOO</label>
                        </div>
                        <div class="checks-wrap">
                          <input
                            id="cpSpdTp2"
                            v-model="item.assign_action"
                            :value="2"
                            name="assignAction"
                            type="radio"
                          />
                          <label for="cpSpdTp2">Tạo OOS</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="item.assign_action === 1 || item.assign_action === 2"
                  class="das-form-row"
                >
                  <div class="das-form-col col-4">
                    <validation-provider
                      rules="required"
                      name="Trạng thái phòng"
                    >
                      <div class="das-form-input">
                        <div class="label required">Trạng thái phòng</div>
                        <el-select v-model="item.room_status" placeholder="">
                          <el-option label="Bẩn" value="1"> </el-option>
                          <el-option label="Sạch" value="2"> </el-option>
                          <el-option label="Đã kiểm tra" value="4"> </el-option>
                        </el-select>
                        <!-- <select v-model="item.room_status">
                          <option value="1">Bẩn</option>
                          <option value="2">Sạch</option>
                          <option value="4">Đã kiểm tra</option>
                        </select> -->
                      </div>
                    </validation-provider>
                  </div>
                  <div class="das-form-col col-4">
                    <validation-provider rules="required" name="Ngày kết thúc">
                      <div class="das-form-input">
                        <div class="label required">Ngày kết thúc</div>
                        <SingleCalendar
                          v-model="item.date_to"
                          :get-time="true"
                        />
                      </div>
                    </validation-provider>
                  </div>
                </div>
              </div>
            </validation-observer>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <span slot="footer" class="dialog-footer">
          <div class="button-containers">
            <button
              class="btn primary small outline"
              @click="dialogFormVisible = false"
            >
              Huỷ
            </button>
            <button v-if="isEdit" class="btn primary small" @click="updateRow">
              Cập nhật
            </button>
            <button v-else class="btn primary small" @click="addNewRequire">
              Tạo mới
            </button>
          </div>
        </span>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import paginationMixin from '@/mixins/paginationMixin'
import { getCodeListApi } from '@/api/common/code'
import {
  getListMaintainJobDashboardApi,
  addNewMaintainJobDashboardApi,
  updateMaintainJobDashboardApi,
  deleteMaintainJobDashboardApi
} from '@/api/houseKeeper/maintain-job-dasboard.js'
import { getCode } from '@/api/common/code'
import { getAllRoomApi } from '@/api/Room/room.js'
import SingleCalendar from '@/components/ui/SingleCalendar.vue'
// import MultiCalendar from '@/components/ui/MultiCalendar.vue'
export default {
  components: {
    SingleCalendar
    // MultiCalendar
  },
  // mixins: [paginationMixin],
  data() {
    return {
      searchDateRange: {},
      reasonOptions: [],
      rowSelected: false,
      totalPage: 10,
      currentPage: 1,
      isEdit: false,
      loading: false,
      item: {
        room_id: null,
        require_by: null,
        priority_type: null,
        work_type: null,
        desc: null,
        assign_action: 0,
        maintenance_position: null,
        room_status: null,
        date_to: null
      },
      requireResultList: {
        total: 0,
        new: 0,
        received: 0,
        rejected: 0,
        completed: 0
      },
      workTypeOptions: [],
      repairLocationOptions: [],
      searchParams: {
        roomId: null,
        workType: null,
        pageSize: 10,
        pageNum: 1,
        requireStatus: [],
        dateFrom1: null,
        dateFrom2: null
      },
      roomOptions: [],
      dialogFormVisible: false,
      columns: [
        {
          headerName: this.$t('grid.column.status'),
          field: 'require_status',
          valueGetter: params => {
            let data
            switch (params.data.require_status) {
              case 1:
                data = this.$t('grid.column.newRequest')
                break
              case 2:
                data = this.$t('grid.column.received')
                break
              case 3:
                data = this.$t('grid.column.rejected')
                break
              case 4:
                data = this.$t('grid.column.completed')
                break
              default:
                break
            }
            return data
          },
          maxWidth: 130
        },
        {
          headerName: this.$t('grid.column.requestDate'),
          field: 'date_from',
          valueGetter: param => {
            return this.$displayDate(param?.data?.date_from) || null
          },
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.workType'),
          field: 'work_type_name',
          tooltipField: 'work_type_name',
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.processingTime'),
          field: 'processing_time',
          valueGetter: params => {
            if (params.data.processing_time) {
              return params.data.processing_time + ' giờ'
            } else {
              return null
            }
          },
          maxWidth: 120
        },
        {
          headerName: this.$t('grid.column.room'),
          field: 'room_num',
          maxWidth: 130
        },
        {
          headerName: this.$t('grid.column.workDesc'),
          field: 'desc_string',
          tooltipField: 'desc_string'
        },
        {
          headerName: this.$t('grid.column.assignAction'),
          field: 'assign_action',
          valueGetter: params => {
            let data
            switch (params.data.assign_action) {
              case 0:
                data = ''
                break
              case 1:
                data = 'Tạo OOO'
                break
              case 2:
                data = 'Tạo OOS'
                break
              default:
                break
            }
            return data
          }
        },
        {
          headerName: this.$t('grid.column.dateRequestCompleted'),
          field: 'date_to',
          valueGetter: param => {
            return this.$displayDate(param?.data?.date_to) || null
          }
        },
        {
          headerName: this.$t('grid.column.priority'),
          field: 'priority_type',
          valueGetter: params => {
            let data
            switch (params.data.priority_type) {
              case 1:
                data = 'Thấp'
                break
              case 2:
                data = 'Trung bình'
                break
              case 3:
                data = 'Cao'
                break
              default:
                break
            }
            return data
          },
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.requestBy'),
          field: 'require_by',
          tooltipField: 'require_by',
          maxWidth: 150
        },
        // {
        //   headerName: this.$t('grid.column.receivedDate'),
        //   field: 'received_date',
        //   valueGetter: param => {
        //     return this.$displayDate(param?.data?.received_date) || null
        //   }
        // },
        // {
        //   headerName: this.$t('grid.column.receivedPerson'),
        //   field: 'receiver_name',
        //   tooltipField: 'receiver_name',
        //   maxWidth: 150
        // },
        // {
        //   headerName: this.$t('grid.column.receivedDesc'),
        //   field: 'receive_descr',
        //   tooltipField: 'receive_descr'
        // },
        {
          headerName: this.$t('grid.column.finishDate'),
          field: 'finish_date',
          valueGetter: param => {
            return this.$displayDate(param?.data?.finish_date) || null
          }
        },
        {
          headerName: this.$t('grid.column.finishPerson'),
          field: 'finish_person_name'
        },
        {
          headerName: this.$t('grid.column.finishDesc'),
          field: 'finish_descr'
        }
        // {
        //   headerName: this.$t('grid.column.rejectedDate'),
        //   field: 'refuse_date',
        //   valueGetter: param => {
        //     return this.$displayDate(param?.data?.refuse_date) || null
        //   }
        // },
        // {
        //   headerName: this.$t('grid.column.rejectedPerson'),
        //   field: 'refuse_person_name'
        // },
        // {
        //   headerName: this.$t('grid.column.rejectedDesc'),
        //   field: 'refuse_descr',
        //   tooltipField: 'refuse_descr'
        // }
      ],
      searchColumn1: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: 'Trạng thái',
          field: 'name',
          flex: 1
        }
      ],
      searchRows1: [
        {
          value: 1,
          name: 'Yêu cầu mới'
        },
        // {

        //   value: 2,
        //   name: 'Đã nhận'
        // },
        // {
        //   value: 3,
        //   name: 'Từ chối'
        // },
        {
          value: 4,
          name: 'Hoàn thành'
        }
      ],
      rows: []
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetInfo()
    },
    'item.assign_action'() {
      if (this.item.assign_action === 0) {
        this.item.room_status = null
        this.item.date_to = null
      }
    },
    searchDateRange(data) {
      this.searchParams.dateFrom1 = data.start
      this.searchParams.dateFrom2 = data.end
    }
  },
  async mounted() {
    const data1 = await getAllRoomApi()
    const data2 = await getCode({
      p_code: 'WORK_TP'
    })
    const data3 = await getCode({
      p_code: 'MAINTENANCE_LOCATION'
    })
    const data4 = await getCodeListApi({
      pCode: 'RSS'
    })
    this.workTypeOptions = data2.data || []
    this.repairLocationOptions = data3.data || []
    this.roomOptions = data1.data || []
    this.reasonOptions = data4.data || []
    // this.searchParams.roomId = this.roomOptions[0].id
    await this.attachData()
  },
  methods: {
    selectionChanged(params) {
      this.rowSelected = params
    },
    onReset() {
      this.$nullValueInObj(this.searchParams)
      this.searchDateRange = {}
      this.searchParams.requireStatus = []
      this.searchParams.pageSize = 10
      this.searchParams.pageNum = 1
      this.attachData()
    },
    onSelectMultipleRowSearch1(val) {
      this.searchParams.requireStatus = val?.map(item => item.value) ?? null
    },
    resetInfo() {
      this.item = {
        room_id: null,
        require_by: null,
        priority_type: null,
        work_type: null,
        desc: null,
        assign_action: 0,
        maintenance_position: null,
        room_status: null,
        date_to: null
      }
      this.isEdit = false
    },
    async onPageChanged(pageNum) {
      this.searchParams.pageNum = pageNum
      await this.attachData()
    },
    async onPageSizeChange(pageSize) {
      this.searchParams.pageSize = pageSize
      this.searchParams.pageNum = 1
      await this.attachData()
    },
    async addNewRequire() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      await addNewMaintainJobDashboardApi(this.item)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
      // console.log('addNewRequire', this.item)
    },
    onEditRow() {
      const gridApi = this.$refs.agGrid.gridApi
      const row = gridApi.getSelectedRows()[0]
      if (!row) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
        return false
      }
      this.isEdit = true
      this.dialogFormVisible = true
      Object.assign(this.item, row)
    },
    async updateRow() {
      await updateMaintainJobDashboardApi(this.item)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    onChangeDate(startDate, endDate) {
      this.searchParams.dateFrom1 = startDate
      this.searchParams.dateFrom2 = endDate
      // console.log('onChangeDate: ', startDate, endDate)
    },
    async attachData() {
      const data = await getListMaintainJobDashboardApi(this.searchParams)
      data.data.number_of_status.forEach(item => {
        switch (item.require_status) {
          case 0:
            this.requireResultList.total = item.number
            break
          case 1:
            this.requireResultList.new = item.number
            break
          case 2:
            this.requireResultList.received = item.number
            break
          case 3:
            this.requireResultList.rejected = item.number
            break
          case 4:
            this.requireResultList.completed = item.number
            break
          default:
            break
        }
      })
      this.rows = data.data.room_require
      this.totalPage = Math.ceil(data.total / this.searchParams.pageSize)
      this.currentPage = data.data.length === 0 ? 0 : data.page_num
      this.rowSelected = []
    },
    async onDeleteRow() {
      const gridApi = this.$refs.agGrid.gridApi
      const row = gridApi.getSelectedRows()[0]
      if (!row) {
        this.$message({
          type: 'error',
          message: 'Chọn ít nhất một hàng'
        })
        return false
      }
      this.$vxConfirm(this.$t('alert.deleteConfirm'), async () => {
        await deleteMaintainJobDashboardApi({
          id_list: [row.id]
        })
          .then(async res => {
            const message = res.message
            await this.attachData()
            this.dialogFormVisible = false
            this.$message({
              type: 'success',
              message: this.$t(`successMsg.${message}`)
            })
          })
          .catch(error => {
            const message = error.response?.data?.message || 'default'
            this.$message({
              type: 'error',
              message: this.$t(`errorMsg.${message}`)
            })
          })
      })
    }
  }
}
</script>

<style lang="scss"></style>
